/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCalculationitem } from '../models/work-calculationitem';
import { WorkCreateCalculationitemDto } from '../models/work-create-calculationitem-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateCalculationitemDto } from '../models/work-update-calculationitem-dto';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceCalculationitemsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceCalculationitemsV2ControllerGetCalculationitemsByProjectId()` */
  static readonly SelfserviceCalculationitemsV2ControllerGetCalculationitemsByProjectIdPath = '/v2/selfservice/calculationitems/byProjectId/{projectId}';

  /**
   * Get all calculation items by project ID.
   *
   * Returns all calculation items for the specified project if it belongs to the authenticated contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceCalculationitemsV2ControllerGetCalculationitemsByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceCalculationitemsV2ControllerGetCalculationitemsByProjectId$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceCalculationitemsService.SelfserviceCalculationitemsV2ControllerGetCalculationitemsByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Get all calculation items by project ID.
   *
   * Returns all calculation items for the specified project if it belongs to the authenticated contact
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceCalculationitemsV2ControllerGetCalculationitemsByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceCalculationitemsV2ControllerGetCalculationitemsByProjectId(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.selfserviceCalculationitemsV2ControllerGetCalculationitemsByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `selfserviceCalculationitemsV2ControllerCreateCalculationitemForProject()` */
  static readonly SelfserviceCalculationitemsV2ControllerCreateCalculationitemForProjectPath = '/v2/selfservice/calculationitems/forProject/{projectId}/{groupName}';

  /**
   * Create a new calculation item for a project.
   *
   * Creates a new calculation item for the specified project if it belongs to the authenticated contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceCalculationitemsV2ControllerCreateCalculationitemForProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceCalculationitemsV2ControllerCreateCalculationitemForProject$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;

    /**
     * CalculationItem group name
     */
      groupName: string;

    /**
     * onlyIfNotExist
     */
      onlyIfNotExist?: boolean;
  
    /**
     * Calculation item data to create (calculationId will be determined automatically)
     */
    body: WorkCreateCalculationitemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceCalculationitemsService.SelfserviceCalculationitemsV2ControllerCreateCalculationitemForProjectPath, 'post');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.path('groupName', params.groupName, {});
      rb.query('onlyIfNotExist', params.onlyIfNotExist, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Create a new calculation item for a project.
   *
   * Creates a new calculation item for the specified project if it belongs to the authenticated contact
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceCalculationitemsV2ControllerCreateCalculationitemForProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceCalculationitemsV2ControllerCreateCalculationitemForProject(
    params: {

    /**
     * Project ID
     */
      projectId: number;

    /**
     * CalculationItem group name
     */
      groupName: string;

    /**
     * onlyIfNotExist
     */
      onlyIfNotExist?: boolean;
  
    /**
     * Calculation item data to create (calculationId will be determined automatically)
     */
    body: WorkCreateCalculationitemDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.selfserviceCalculationitemsV2ControllerCreateCalculationitemForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

  /** Path part for operation `selfserviceCalculationitemsV2ControllerDeleteCalculationitem()` */
  static readonly SelfserviceCalculationitemsV2ControllerDeleteCalculationitemPath = '/v2/selfservice/calculationitems/{id}';

  /**
   * Delete a calculation item.
   *
   * Deletes a calculation item if it belongs to a project owned by the authenticated contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceCalculationitemsV2ControllerDeleteCalculationitem()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceCalculationitemsV2ControllerDeleteCalculationitem$Response(
    params: {

    /**
     * Calculation item ID
     */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceCalculationitemsService.SelfserviceCalculationitemsV2ControllerDeleteCalculationitemPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Delete a calculation item.
   *
   * Deletes a calculation item if it belongs to a project owned by the authenticated contact
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceCalculationitemsV2ControllerDeleteCalculationitem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceCalculationitemsV2ControllerDeleteCalculationitem(
    params: {

    /**
     * Calculation item ID
     */
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.selfserviceCalculationitemsV2ControllerDeleteCalculationitem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `selfserviceCalculationitemsV2ControllerUpdateCalculationItem()` */
  static readonly SelfserviceCalculationitemsV2ControllerUpdateCalculationItemPath = '/v2/selfservice/calculationitems/{id}';

  /**
   * Update a calculation item.
   *
   * Update a calculation item
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceCalculationitemsV2ControllerUpdateCalculationItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceCalculationitemsV2ControllerUpdateCalculationItem$Response(
    params: {

    /**
     * calculationItem ID
     */
      id: number;
  
    /**
     * calculation-item data to update
     */
    body: WorkUpdateCalculationitemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceCalculationitemsService.SelfserviceCalculationitemsV2ControllerUpdateCalculationItemPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Update a calculation item.
   *
   * Update a calculation item
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceCalculationitemsV2ControllerUpdateCalculationItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  selfserviceCalculationitemsV2ControllerUpdateCalculationItem(
    params: {

    /**
     * calculationItem ID
     */
      id: number;
  
    /**
     * calculation-item data to update
     */
    body: WorkUpdateCalculationitemDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.selfserviceCalculationitemsV2ControllerUpdateCalculationItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
